<div class="pagination">
  <p class="pagination__meta">
    Page <strong>{{ currentPage }}</strong> of <strong>{{ totalPages }}</strong>
    · <strong>{{ totalItems }}</strong> items
  </p>
  <div class="pagination__controls">
    <button type="button" class="pagination__btn" [disabled]="disabled || currentPage === 1" (click)="onPageChange(currentPage - 1)">
      Prev
    </button>
    <button type="button" class="pagination__page" [disabled]="disabled" [class.pagination__page--active]="currentPage === 1" (click)="onPageChange(1)">1</button>
    @if (startPage > 2) {
      <span class="pagination__ellipsis">…</span>
    }
    @for (pageNum of getPageNumbers(); track pageNum) {
      <button
        type="button"
        class="pagination__page"
        [disabled]="disabled"
        [class.pagination__page--active]="currentPage === pageNum"
        (click)="onPageChange(pageNum)"
      >
        {{ pageNum }}
      </button>
    }
    @if (endPage < totalPages - 1) {
      <span class="pagination__ellipsis">…</span>
    }
    @if (totalPages > 1) {
      <button
        type="button"
        class="pagination__page"
        [disabled]="disabled"
        [class.pagination__page--active]="currentPage === totalPages"
        (click)="onPageChange(totalPages)"
      >
        {{ totalPages }}
      </button>
    }
    <button
      type="button"
      class="pagination__btn"
      [disabled]="disabled || currentPage >= totalPages"
      (click)="onPageChange(currentPage + 1)"
    >
      Next
    </button>
  </div>
</div>
